export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看单据',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ proofingStatus }) => !['N'].includes(proofingStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ proofingStatus }) => !['N'].includes(proofingStatus),
  },
  {
    text: that.$l('menu_text_confirm') || '确认下单',
    icon: 'el-icon-s-check',
    menuType: 'confirm',
    divided: true,
    allow: 'C',
    disabled: ({ proofingStatus }) => !['N'].includes(proofingStatus),
  },
  {
    text: that.$l('menu_text_receive') || '收货确认',
    icon: 'el-icon-box',
    menuType: 'receive',
    allow: 'R',
    disabled: ({ proofingStatus }) => !['Y'].includes(proofingStatus),
  },
  {
    text: that.$l('menu_text_quality') || '品质确认',
    icon: 'el-icon-s-claim',
    menuType: 'quality',
    allow: 'P',
    disabled: ({ proofingStatus }) => !['Y'].includes(proofingStatus),
  },
]
